<div class="container mt-2 mb-0">
  <div class="row justify-content-center my-4">
    <div class="col-12 col-md-8">
      <div class="row rounded pb-3">

        @if(loading()) {
          <mat-progress-spinner
            color="primary"
            mode="indeterminate"
          >
          </mat-progress-spinner>
        }
        @else {
          @if(cartError()) {
            <div class="error-section">Error: {{cartError()}}</div>
          }    
          @if(cartCompleted()) {
            <div>This cart is already paid</div>
          }
          @if(!cartError() && !cartCompleted()) {
            <equine-ui-nx-order-summary
              [subtotal]="subTotal()"
              [subtotalCount]="totalItems()"
              [coupon]="coupon()"
              [donation]="donationOrderTotal()"
              [total]="total()"
              (goBack)="goBack()"
            ></equine-ui-nx-order-summary>
          }
        }
      </div>
    </div>

    <div class="col-12 col-md-4">
      <mat-card class="p-0 shadow">
        <mat-card-title class="text-center my-2 pb-1">Proceed to Payment</mat-card-title>
        <hr class="p-0 mb-4 mt-0">
        <div class="row justify-content-center mb-4">
          <div class="col-md-10">
            @if(paymentMethods.length) {
              <equine-ui-nx-bt-ach-accounts
                [paymentMethods]="paymentMethods"
                [loading]="paying()"
                (selected)="payWithToken($event)"
                (removed)="removePaymentMethod($event)"
                (verified)="openVerificationDialog($event)"
              >
              </equine-ui-nx-bt-ach-accounts>
            }
            @if(clientLoaded()) {
              <button mat-raised-button color="primary" class="full-width" (click)="addNewBankAccount()" [disabled]="paying()">ADD NEW BANK ACCOUNT</button>
            }
          </div>
        </div>
      </mat-card>
    </div>


  </div>

</div>


